import React, {Component} from "react";
import BannderHead from "../../components/layout/BannderHead";
import axios from "axios";
import Pagination from "../../components/Pagination";
import DatePicker from "react-datepicker2";
import {groupBy, entries} from "lodash";

var moment = require('moment-jalaali')


export default class AdminOrdersDescriptionListPage extends Component {
    state = {
        orders: [],
        pagination: {},
        translate: {
            fa: {
                send: "ارسال سفارش",
                fast: "ارسال فوری",
                inPerson: "تحویل حضوری",
                normal: "ارسال عادی"
            }

        }
    }

    constructor() {
        super();
        this.state.isShow = 'daily';
    }

    async componentDidMount() {
        await this.getOrders();

    }


    getOrders = async () => {
        let URL = '';
        if (this.props.today) {
            URL = window.admin_base_URL + '/orders/ordersByClient/today/'
        } else {
            URL = window.admin_base_URL + '/orders/ordersByClient'
        }

        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page');
        if (page) URL = window.admin_base_URL + '/orders/ordersByClient?page=' + page
        let pagination = {};
        let data = [];
        await axios.get(URL)
            .then(res => {
                data = res.data.result
                pagination = res.data.pagination

            }).catch(err => {
                console.error(err)
            })
        console.log(data);
        let source = data.filter(item=> {
            if(item.description)
                return item;
        })
        console.log(source);
        console.log(333);
        this.setState(() => {
            return {orders: source, pagination: pagination};
        });
    }



    render() {


        let {orders, pagination} = this.state;
        let {today} = this.props;

        return (
            <div className="ps-page pb-75">
                <BannderHead className="no-print" title={'توضیحات ارسال امروز'}/>
                <BannderHead className="just-print" title={'توضیحات ارسال ' + moment(new Date()).format('jYYYY/jMM/jDD')}/>


                <div className='ml-4 mb-4 d-flex'>
                    <div className="w-50 text-right">
                        <span>تعداد کل: {orders.length}</span>&nbsp;;&nbsp;
                        <span>تعداد نمایش در صفحه : {pagination.limit}</span>&nbsp;;&nbsp;
                        <span>شماره صفحه : {pagination.page}</span>
                    </div>
                    <div className="w-50">
                        <Pagination pagination={pagination}/>
                    </div>
                </div>

                <table className="table table-hover table-striped text-right mb-4 font-big-print">
                    <thead>
                    <tr>
                        <th scope="col">مشخصات مشتری</th>
                        <th scope="col">توضیحات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {orders.map((item, index) => {
                        return <tr key={index}>
                            {item.client ? <td className="w-print-30">
                                <div className="no-print bolder">{item.client.shopTitle}</div>
                                <div className="just-print bolder">نام فروشگاه: {item.client.shopTitle}</div>
                                <div className="no-print">{item.client.name}</div>
                                <div className="just-print">نام مشتری: {item.client.name}</div>
                                <div className="no-print">{item.client.phone}</div>
                                <div className="just-print">تلفن مشتری: {item.client.phone}</div>
                                <div className="no-print">{item.client.address}</div>
                                <div className="just-print">آدرس ارسال: {item.client.address}</div>
                                <div className='mb-10 mb-print-0'>کدپستی: {item.client.postCode}</div>
                                <div className="just-print">نوع ارسال: {this.state.translate.fa[item.howToSend]}</div>

                            </td> : <td></td>}
                            <td>{item.description}</td>
                        </tr>
                    })}
                    </tbody>
                </table>
                <Pagination pagination={pagination}/>
            </div>
        );
    }
}
